import { Input } from 'reactstrap'

export default function FileInput({ fieldId, handleChange, accept }) {
  console.log(`FileInput rendered: ${fieldId}`)

  return (
    <Input
      value=""
      type="file"
      name={fieldId}
      style={{ display: 'none' }}
      id={fieldId}
      onChange={(event) => handleChange(event)}
      accept={accept}
    />
  )
}
